import {
  FArrangementTypesEnum,
  FCompositionTypesEnum,
  FEnsembleTypesEnum,
} from '@spazious/dollhouse-shallow-graph';

export const compositionSchemaType = (
  type: FCompositionTypesEnum,
  subtype: FEnsembleTypesEnum | FArrangementTypesEnum
) => {
  let suffix = '';
  let prefix = '';
  if (type === FCompositionTypesEnum.FEnsemble) {
    suffix = 'ensemble';
    if (subtype === FEnsembleTypesEnum.Desktop) {
      prefix = 'classroom';
    } else if (subtype === FEnsembleTypesEnum.Round) {
      prefix = 'round';
    } else if (subtype === FEnsembleTypesEnum.Cabaret) {
      prefix = 'cabaret';
    } else if (subtype === FEnsembleTypesEnum.Boardroom) {
      prefix = 'boardroom';
    }
  } else if (type === FCompositionTypesEnum.FArrangement) {
    suffix = 'arrangement';
    if (subtype === FArrangementTypesEnum.Classroom) {
      prefix = 'classroom';
    } else if (subtype === FArrangementTypesEnum.Round) {
      prefix = 'round';
    } else if (subtype === FArrangementTypesEnum.Cabaret) {
      prefix = 'cabaret';
    } else if (subtype === FArrangementTypesEnum.Theater) {
      prefix = 'theater';
    } else if (subtype === FArrangementTypesEnum.Cocktail) {
      prefix = 'cocktail';
    } else if (subtype === FArrangementTypesEnum.Boardroom) {
      prefix = 'boardroom';
    } else if (subtype === FArrangementTypesEnum.Ushape) {
      prefix = 'ushape';
    }
  }
  return `${prefix}-${suffix}`;
};
